import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { DialogTitle, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdAddCircle, MdApproval, MdArrowBack, MdArrowRightAlt, MdCheckCircle, MdClass, MdDone, MdEmail, MdFactCheck, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdPendingActions, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility, MdStorage, MdTimer } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";

function ResearcherResetPassword() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setUserDetail(() => ({ email: "", role: "" }))
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [userDetail, setUserDetail] = useState({
        email: '',
        role: ''
    })

    const [error, setError] = useState({
        invalidEmail: false,
        noEmail: false,
        noRole: false,
    })

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
            // console.log("1");

        } else if (err.toLowerCase().includes('not found')) {
            setErrorMsg(t('t257'));
            // console.log("2");
        } else {
            setErrorMsg(t('t94'));
            // console.log("3");
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        setUserDetail(() => ({ email: "", role: "" }))
    };

    const handleButtonClick = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let newErrors = {};

        newErrors.noEmail = !userDetail.email;
        newErrors.noRole = !userDetail.role;

        if ((userDetail.email) && !emailRegex.test(userDetail.email)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        setError(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.put(`${web_url}/api/auth/forgot-password/${userDetail.email}?userRole=${userDetail.role}`, {}, configToken)
            .then((response) => {
                setOpen(true)
                setIsLoading(false);
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.data) {
                        handleClickOpenError(err.response.data);
                        console.log(err.response.data)
                    } else if (err.response.message) {
                        handleClickOpenError(err.response.message);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })
    }

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const recepientArray = ['TEACHER', 'TRANSLATOR', 'STUDENT'];

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} w-screen xl:pt-[20px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/mobile/researcher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/mobile/researcher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/desktop/researcher/dashboard')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t113')}</p>
                    </div>
                </div>

                <div className="flex justify-center mt-[40px]">
                    <img src="/images/reset_password.svg" alt="reset password" />
                </div>

                <div className="ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] md:mt-[40px] xl:mt-[10px] flex h-[50px]  md:h-[60px] xl:h-[50px] 2xl:h-[60px] justify-center">
                    <Menu as="div" className="w-full  relative inline-block text-left py-[20px]">
                        <div>
                            <MenuButton
                                className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] ${i18n.language === "en" ? "text-[15px] md:text-[17px]" : "text-[10px] md:text-[15px]"} ${userDetail.role === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                            >
                                <p className={"pr-[10px] text-gray-500"}>{t('t211')}:</p>
                                {userDetail.role === "" ? t('t210') : userDetail.role}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className="absolute right-[10px] size-5 text-gray-700"
                                />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            style={{
                                width: '100%',
                                maxHeight: '100px',
                                overflowY: 'auto'
                            }}
                        >
                            <div className="py-1">
                                {
                                    recepientArray.map((recepientSelect, index) => (
                                        <MenuItem key={index}>
                                            <button
                                                className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                onClick={() => {
                                                    setUserDetail((prev) => ({ ...prev, role: recepientSelect }))
                                                }}
                                            >
                                                {recepientSelect}
                                            </button>
                                        </MenuItem>
                                    ))
                                }
                            </div>
                        </MenuItems>
                    </Menu>
                </div>

                {error.noRole &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px] ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px]'>{t('t210')}</p>
                }

                <div className="ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdEmail size="24px" color="#8189B0" />
                    <input type="text" value={userDetail.email} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t148')}
                        onChange={(e) => {
                            setUserDetail((prev) => ({ ...prev, email: e.target.value.toLowerCase() }))
                        }}
                    />
                </div>

                {error.noEmail &&
                    <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                }
                {error.invalidEmail &&
                    <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                }

                <div className="flex justify-center">
                    <button onClick={handleButtonClick} disabled={isLoading} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[300px] md:w-[400px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">
                        {isLoading ? (
                            <div className="items-center justify-center flex">
                                <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                            </div>
                        ) : (
                            t('t116')
                        )}
                    </button>
                </div>

                <div className="flex w-full justify-center xl:mt-[20px] 2xl:mt-[60px] pb-[200px]">
                    <div className="w-[100%] md:w-[60%] xl:w-[25%] mt-[20px] flex justify-center items-center ml-[10px] cursor-pointer px-[20px]" onClick={() => navigate('/researcher/resetpassword/student/check')}>
                        <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                            <MdPassword size={30} color="#FDC50C" />
                        </div>
                        <div className="bg-[#FFEBA9] py-[12px] 2xl:py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                            <p className="overflow-hidden text-ellipsis  text-black text-[13px] 2xl:text-[16px] font-bold">{t('t113_2')}</p>
                        </div>
                    </div>
                </div>

            </div>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px] mb-[20px]'>{t('t127')}</div>
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </div>
                        </DialogContent>
                    }
                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2 ">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ResearcherResetPassword;
